import Attachment from "./attachment";

export default class Message {
  readonly id: number
  readonly userName: string
  readonly userId: string
  readonly userAvatar: string
  readonly content: string
  readonly reasoningContent: string
  readonly threadId: string
  readonly clientRequestId?: string
  readonly generationState?: 'queued' | 'running' | 'generating' | 'stalled' | 'stopped' | 'failed'
  readonly isBot: boolean
  readonly attachments: Attachment[]
  readonly contentRaw: string
  readonly agentId: number | null
  readonly citedSources: any
  readonly learningDialog?: { status: 'generating' | 'running' | 'asking' | 'complete' | 'failed' | 'cancelled'; kind: 'check' | 'review'; round: number; userExamId?: number; runVersion?: number }
  readonly agentActivities: any[]
  readonly created_at: string
  public speechPlaying: boolean = false
  public cachedSpeechUrl: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.userName = data.userName
    this.userId = data.userId
    this.userAvatar = data.userAvatar
    this.content = data.content
    this.reasoningContent = data.reasoningContent
    this.isBot = data.isBot
    this.threadId = data.threadId
    this.clientRequestId = data.clientRequestId
    this.generationState = data.generationState
    this.attachments = data.attachments
    this.contentRaw = data.contentRaw
    this.agentId = data.agentId
    this.citedSources = data.citedSources || { cited: [], related: [] }
    this.learningDialog = data.learningDialog
    this.agentActivities = data.agentActivities || []
    this.created_at = data.created_at || data.createdAt || ''
  }
}
